<template lang="pug">
  //- transition(
  //-   appear
  //- )

  #site-container
    Preloader(v-show="isPreloading")
    //- ne pas utiliser v-if v-else car l'ordre du dom n'est pas conservé

    //- attention v-show ne fonctionne pas sur un élément template

    ais-index(
      :app-id='appId',
      :api-key='apiKey',
      :index-name='indexName',
      :query="searchQuery"
      :query-parameters="queryParameters"
      )
      div(v-if="!isPreloading")
        cookie-law(theme="mv", :buttonText="$t('cookiebar.cta')")
          div(slot="message") {{$t('cookiebar.message')}} <router-link to="legal-notes">{{$t('cookiebar.legal')}}</router-link>
        router-view
        SearchSide
        HeaderSearchInput(ref="headerSearch")
        Menu
        HeaderLogo(ref="headerLogo")
          slot(name="header")
        FullscreenImgViewer(v-if="fullscreenImgViewerOptions" :src="fullscreenImgViewerOptions.src" :thumbEl="fullscreenImgViewerOptions.thumbEl" @close="closeFullScreenImgViewerHandler")
</template>

<script>
import SearchSide from '@/components/SearchSide'
import Menu from './components/Menu'
import HeaderLogo from './components/HeaderLogo'
import HeaderSearchInput from './components/HeaderSearchInput'
import FullscreenImgViewer from './components/FullscreenImgViewer'
import Preloader from './components/Preloader'
import CookieLaw from 'vue-cookie-law'
import {mapGetters} from 'vuex'
import store from '@/store'
import * as MUTATION from './const.mutations'

export default {
  components: {
    SearchSide,
    Menu,
    HeaderLogo,
    HeaderSearchInput,
    FullscreenImgViewer,
    Preloader,
    CookieLaw
  },
  data () {
    return {
      isPreloading: true,
      isOpened: false,
      meta: null,
      defaultMeta: {
        title: this.$t('meta.title.default'),
        meta: [
          { vmid: 'description', name: 'description', content: this.$t('meta.description') }
        ]
      }
    }
  },
  metaInfo () {
    return this.meta || this.defaultMeta
  },
  computed: {
    ...mapGetters(['fullscreenImgViewerOptions', 'searchQuery']),
    apiKey () {
      return process.env.VUE_APP_ALOGLIA_API_KEY
    },
    appId () {
      return process.env.VUE_APP_ALOGLIA_APP_ID
    },
    indexName () {
      return process.env.VUE_APP_ALOGLIA_INDEX_NAME
    },
    queryParameters () {
      return {filters: `entity_id:sample AND search_api_language:${this.$i18n.locale}`, hitsPerPage: MUTATION.RESULTS_LIMIT}
    }
  },
  created () {
    this.fetchMeta()
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.$tools.isTouchDevice()) { document.body.classList.add('isNoTouchDevice') }

      var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS')
      var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      var isIE = navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)

      if (isSafari) { document.body.classList.add('safari') }
      if (isFirefox) { document.body.classList.add('firefox') }
      if (isIE) { document.body.classList.add('ie') }
    })

    // TODO - implementer le prechargement
    // TMP - Faux préchargement entre 1 et 4 secondes
    setTimeout(() => this.isPreloading = false, Math.random() * 3000 + 3000)
    // this.isPreloading = false

    this.updateViewportSize()

    // On écoute les évènements de resize
    window.addEventListener('resize', this.viewportResizeHandler)
    window.addEventListener('orientationchange', this.viewportResizeHandler)

    //
    // this.$refs.headerLogo.playLogo()
    // this.$refs.headerLogo.onResize()
    // this.$refs.headerSearch.onResize()

    this.isOpened = true

    this.$raf.init()
  },
  beforeDestroy () {
    // On arrête d'écouter les évènements de resize
    window.removeEventListener('resize', this.viewportResizeHandler)
    window.removeEventListener('orientationchange', this.viewportResizeHandler)
  },
  watch: {
    $route (to, from) {
      if (!this.isPreloading) {
        this.$refs.headerLogo.playLogo()
        this.$refs.headerLogo.onResize()
        this.$refs.headerSearch.onResize()

        if (to.name === 'search') { this.$refs.headerSearch.openSearch() } else { this.$refs.headerSearch.closeSearch() }
      }
    }
  },
  methods:
  {
    fetchMeta () {
      this.$api.getMainMetaTag(this.$i18n.locale)
        .then(response => {
          this.meta = this.$metatag.formateMeta(response.data)
        })
    },
    /**
     * Callback au resize du viewport
     */
    viewportResizeHandler (e) {
      this.updateViewportSize()
    },
    /**
     * Lorsque la taille du viewport change
     */
    updateViewportSize () {
      // On dit au store de mettre à jour la taille du viewport
      store.dispatch('updateViewportSize')
    },
    closeFullScreenImgViewerHandler () {
      store.dispatch('setFullscreenImgOptions', null)
    }
  }
}
</script>

<style lang="stylus">
// Stylus variables are auto-loaded

@import '../styles/mixins'
@import '../styles/default'
@import '../styles/inputs'

@import '../styles/abstract-components/**'

// GENERIC
global-reset()
reset-html5()

*:focus
  outline none!important

*
	-webkit-font-smoothing: antialiased
	font-smoothing: antialiased
	user-select none

body
  height 100%
  width 100%
  margin 0px
  font-family: $font;
  padding 0px
  position absolute
  top 0px
  left 0px
  right 0px
  bottom 0px
  background-color $grey-1
  overflow hidden

.normal-enter,
.reverse-leave-to
  transform translate3d(20%, 0, 0)
  opacity 0

.normal-leave-to,
.reverse-enter
  transform translate3d(-20%, 0, 0)
  opacity 0

.normal-enter-active
.reverse-enter-active
  transition all 1.2s $ease

.normal-leave-active
.reverse-leave-active
  transition all 1s $ease

.ps>.ps__scrollbar-y-rail
  z-index 100
  opacity .6

.Cookie--mv, .Cookie

  z-index 10
  position fixed
  background-color black!important
  width calc(100% - 70px)!important
  bottom 0px!important
  left unset!important
  right 0px!important
  background-image url('/img/backgrounds/relief_background_white.png')
  background-position center
  background-size cover
  color white
  padding 30px 50px!important

  @media $mq_s_only

    width calc(100% - 40px)!important
    padding 10px 20px!important
    font-size 14px!important

  a
    color white

  .Cookie__button

    background transparent
    border 1px solid $beige
    color $beige
    padding 10px 40px
    border-radius 50px
    cursor pointer
    white-space: nowrap;
    overflow hidden
    position relative
    backface-visibility: hidden;
    transition: border-color 0.3s, color 0.3s, transform 1s, opacity 0.8s ;
    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
    // transition color 0.8s $ease, border-color 0.8s $ease, background-color 0.8s $ease, transform 1s $ease, opacity 0.8s $ease

    &:before

      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 150%;
      height: 100%;
      background: white;
      z-index: -1;
      transform: rotate3d(0, 0, 1, -45deg) translate3d(0, 3em, 0);
      transform-origin: 100% 0%;
      transition: transform 0.3s, opacity 0.3s, background-color 0.3s;

    @media $mq_s_only
      font-size 14px
      white-space: normal;
      padding 10px 25px

    &:hover

      border-color transparent
      color $black
      transform scale(0.98) translateZ(0) perspective(1px)

      &:before

        opacity: 1;
        background-color: $beige;
        transform: rotate3d(0, 0, 1, 0deg);
        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);

    &:focus

      transform scale(0.95) translateZ(0) perspective(1px)
      opacity 0.5

</style>

<style lang="stylus" scoped>
#site-container
  .FullscreenImgViewer
    // cursor: url('/img/ui/cursor-zoom-out.svg') 32 32, zoom-out

</style>
